module.exports = __webpack_public_path__ + "img/gift18.649b453d.png";